import { loadClamp } from "../es6/clamp-loader";
import { store } from "~/state/store";
import * as Provider from "~/util/providers/photo";
import Scene from "~/scene";
import Canonical from "~/canonical";
import Notifications from "~/util/notifications";
import { setCoordinates } from "~/state/map/state";

/* Pouzdro na lazyloadovany detail fotky */
/* Lazyloadovany detail fotky - vstupni bod */
export default class PhotoDetail {
	_active: boolean;

	_options: {
		id?: number;
		source?: string;
		galleryType?: string;
		[key: string]: any;
	};

	_detail: any;

	_loadPromise: Promise<Array<any>>;

	_keyboardMode: number;

	_onClose: (type: string, data?: any) => void;

	constructor() {
		this._active = false;
		this._options = {};
		this._detail = null;
		this._loadPromise = null;
		this._keyboardMode = 0;
		this._onClose = (type: string, data?: any) => {
			const options = this._options;

			this.deactivate();

			const galleryLogData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : options?.galleryType ? { galleryType: options.galleryType } : {};

			Mapy.getComponent("logger").log("gallery_detail_close", Object.assign(galleryLogData, {
				galleryType: galleryLogData.galleryType ? galleryLogData.galleryType : "photomap",
				section: "gallery",
			}));

			if (type === "photo-delete" && data) {
				Provider.clear(data.source, data.id);

				if (Mapy.getComponent("gallery").isActive()) {
					const galerryData = Mapy.getComponent("gallery").getData();

					Provider.clear(galerryData.source, galerryData.id);
					Mapy.getComponent("gallery").deactivate();
					Mapy.getComponent("gallery").setState({
						source: galerryData.source,
						id: galerryData.id,
					});
				}
			}

			if (type === "close-map-click" && !Mapy.getComponent("gallery").isActive() && Scene) {
				store.dispatch(setCoordinates({
					longitude: data.mark.lon,
					latitude: data.mark.lat,
					zoom: 19,
					animate: true,
				}));
			}

			options.onClose && options.onClose(type || "close", data);

			if (type !== "extern-close") {
				const event = new CustomEvent("photo-detail-close");

				Scene.getContainer().dispatchEvent(event);
			}
		};
	}

	get options() {
		return this._options;
	}

	activate() {
		if (this.isActive()) {
			return this;
		}

		Mapy.getComponent("loader").start();

		if (!this._loadPromise) {
			const imports = [import(
				/* webpackChunkName: "photoDetail" */
				"~/photo/detail/index"
			), loadClamp()];

			this._loadPromise = Promise.all(imports);
		}

		this._loadPromise.then(module => {
			module[0].initModule({ store, Provider, Canonical, Notifications });
			// eslint-disable-next-line new-cap
			this._detail = new module[0].default({
				...this._options,
				...{
					onClose: (type, data) => {
						this._onClose(type, data);

						if (!Mapy.getComponent("history").isFromHistory()) {
							Mapy.getComponent("history").save();
						}
					},
					store,
				},
			});
			this._detail.open();

			// vezmeme mape klavesnici, abychom mohli ovladat sipkama
			const keyboard = Scene.getKeyboardControl();

			if (keyboard) {
				this._keyboardMode = keyboard.getMode();
				keyboard.configure(0);
			}

			const galleryLogData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : this._options?.galleryType ? { galleryType: this._options.galleryType } : {};

			Mapy.getComponent("logger").log("gallery_detail_open", Object.assign(galleryLogData, {
				galleryType: galleryLogData.galleryType ? galleryLogData.galleryType : "photomap",
				section: "gallery",
			}));

			Mapy.getComponent("loader").end();
		});

		this._active = true;

		return this;
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		if (this._detail) {
			this._detail.close();
			this._detail.destroy();
			this._detail = null;
		}

		this._options = {};

		this._active = false;

		// vratime mape ovladani klavesnice
		const keyboard = Scene.getKeyboardControl();

		if (keyboard) {
			keyboard.configure(this._keyboardMode);
		}

		return this;
	}

	isActive() {
		return this._active;
	}

	setState(state: {
		sourcep: string;
		idp: string;
		list: Array<any>;
		[key: string]: any;
	}) {
		if (!Mapy.getComponent("gallery").isActive()) {
			// pro source "index" nechceme otevirat samostatny detail, protoze nemame z ceho
			// ovladani detailu se source "index" resi galerie
			if (state.sourcep && state.idp && state.sourcep !== "index") {
				this.setData({
					source: state.sourcep,
					id: state.idp,
					list: state.list || [],
					...state.galleryType ? { galleryType: state.galleryType } : {},
				}).activate();
			} else if (this._active) {
				this.close();
			}
		}
	}

	getState() {
		let state: {
			sourcep?: string;
			idp?: number;
		} = {};
		const detailData = this._detail?.detailData ? this._detail.detailData : this._options;

		if (detailData.source) {
			state = {
				sourcep: detailData.source,
				idp: detailData.id,
			};
		}

		return state;
	}

	setData(data) {
		this._options = data;

		/*if (this._active && this._detail) {
			this._detail.reload(this._options);
		}*/

		return this;
	}

	close(type = "extern-close", data?) {
		this._onClose(type, data);
	}

	reload(full) {
		Provider.clear(this._options.source, this._options.id);
		this._detail.reopen(full);
	}

	deactivateKeyboard() {
		if (this.isActive() && this._detail) {
			this._detail.deactivateKeyboard();
		}
	}

	activateKeyboard() {
		if (this.isActive() && this._detail) {
			this._detail.activateKeyboard();
		}
	}
}
